import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const PaymentCheck: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m297.37 535.84-60.52 112.65-44.91-59.43c-13.23 9.97-15.86 28.78-5.88 42l33.14 43.9 6.78 9.05c2.95 3.93 7.45 6 12.01 6 3.13 0 6.29-.98 8.99-3 2.59-1.94 6-7 6-7l85-156.44c-14.6-7.82-32.79-2.33-40.61 12.28z' />
    <path d='m600 660.16h-250v-30h220v-345h30z' />
    <path d='m210 555h-30v-434.83h255v29.99h-225z' />
    <path d='m585 300.16h-150c-8.28 0-15-6.72-15-15v-150c0-6.07 3.65-11.54 9.26-13.86 5.6-2.32 12.06-1.04 16.35 3.25l150 150c4.29 4.29 5.57 10.74 3.25 16.35-2.32 5.6-7.79 9.26-13.86 9.26zm-135-30h98.79l-98.79-98.79z' />
    <path d='m305 660.16h224.92s0-30 0-30h-194.92c-16.57 0-30 13.43-30 30z' />
  </IconBase>
));

PaymentCheck.displayName = 'PaymentCheck';

export default PaymentCheck;
